import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/api';

import ParadigmaTable from "../../../../components/ParadigmaTable/ParadigmaTable"
import moment from 'moment';

class Bitacora extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fechaEnvio",
                    width:100,
                    accessor: d=>moment(d.fechaEnvio).format("DD-MM-Y"),
                    show: true,
                },
                {
                    Header: "Remitente",
                    id: "remitente",
                    width:100,
                    accessor: "remitente",
                    show: true,
                },
                {
                    Header: "Destinatario",
                    id: "nombre",
                    accessor: "nombre",
                    show: true,
                },
                {
                    Header: "Enviado a",
                    id: "destinatarios",
                    accessor: "destinatarios",
                    show: true,
                },
                {
                    Header: "Asunto",
                    id: "asunto",
                    accessor: "asunto",
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[ ]}
                apiUrl={api.mails.bitacora}
                columns={this.state.columns}
                title={"Bitacora de Notificaciones"}
            />
        );
    }
}

export default Bitacora;



// WEBPACK FOOTER //
// ./src/views/Configuracion/Mails/Vitacora/Bitacora.js